import { LIST_COOPERATION, LIST_SITE } from "../actions/types";

const initialState = {
  cooperations: [],
  sites: [],
};

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case LIST_COOPERATION:
      return {
        ...state,
        cooperations: action.payload,
      };
    case LIST_SITE:
      return {
        ...state,
        sites: action.payload,
      };
    default:
      return state;
  }
};

export default dashboard;
